import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ActivityItemListItem from "./ActivityItemListItem";
import DateService from "../../../Services/Shared/Date.service";
import HRWithLabel from "../../UI/HRWithLabel/HRWithLabel";
import ActivityItemService from "../../../Domain/ActivityItem/ActivityItem.service";
const ActivityItemWrapper = ({ item, setFeed, editable, hideItemEventTypes, }) => {
    const setActivityItem = React.useCallback((activityItem) => {
        setFeed((oldFeed) => {
            var _a;
            return (oldFeed && Object.assign(Object.assign({}, oldFeed), { items: ((_a = oldFeed === null || oldFeed === void 0 ? void 0 : oldFeed.items) === null || _a === void 0 ? void 0 : _a.map((oldItem) => ActivityItemService.isAboutSameItem(oldItem.activityItem, item.activityItem)
                    ? {
                        activityItem: typeof activityItem === "function"
                            ? activityItem(oldItem.activityItem)
                            : activityItem,
                        updates: oldItem.updates,
                    }
                    : oldItem)) || [] }));
        });
    }, [item.activityItem, setFeed]);
    const deleteActivityItem = React.useCallback(() => {
        setFeed((oldFeed) => oldFeed && Object.assign(Object.assign({}, oldFeed), { items: (oldFeed === null || oldFeed === void 0 ? void 0 : oldFeed.items.filter((oldItem) => !ActivityItemService.isAboutSameItem(oldItem.activityItem, item.activityItem))) || [] }));
    }, [item.activityItem, setFeed]);
    const setItemUpdates = React.useCallback(
    // @ts-expect-error - TS7006 - Parameter 'itemUpdates' implicitly has an 'any' type.
    (itemUpdates) => {
        setFeed((oldFeed) => {
            var _a;
            return oldFeed && Object.assign(Object.assign({}, oldFeed), { items: ((_a = oldFeed === null || oldFeed === void 0 ? void 0 : oldFeed.items) === null || _a === void 0 ? void 0 : _a.map((oldItem) => ActivityItemService.isAboutSameItem(oldItem.activityItem, item.activityItem)
                    ? {
                        activityItem: oldItem.activityItem,
                        updates: typeof itemUpdates === "function"
                            ? itemUpdates(oldItem.updates)
                            : itemUpdates,
                    }
                    : oldItem)) || [] });
        });
    }, [item.activityItem, setFeed]);
    return (_jsx(_Fragment, { children: _jsx(ActivityItemListItem, { activityItem: item.activityItem, itemUpdates: item.updates, hideItemEventTypes: hideItemEventTypes, setActivityItem: setActivityItem, deleteActivityItem: deleteActivityItem, setItemUpdates: setItemUpdates, editable: editable }) }));
};
/**
 * This is a strictly presentational component for displaying the content of an activity feed
 * You probably want to use the ActivityFeed component instead of this one, unless you just want to show a 'static'
 * feed which is not searchable, paged, or auto-reloading.
 */
const ActivityFeedContent = ({ feed, setFeed, editableItems, hideItemEventTypes, }) => {
    const feedWithLabels = React.useMemo(() => {
        let lastDate = null;
        // Group by month.
        const groupedByMonth = feed.reduce((sum, item) => {
            // When the list is updated, it may not be in order.  There may be some items that have new comments/events
            // which will have a greater updated date.  Therefore, we will ignore any dates that are greater than the previous date.
            const effectiveDate = lastDate &&
                item.activityItem.updatedDate.getTime() > (lastDate === null || lastDate === void 0 ? void 0 : lastDate.getTime())
                ? lastDate
                : item.activityItem.updatedDate;
            lastDate = effectiveDate;
            const id = DateService.monthAndYear(effectiveDate);
            // @ts-expect-error - TS2464 - A computed property name must be of type 'string', 'number', 'symbol', or 'any'. | TS2538 - Type 'null' cannot be used as an index type. | TS2538 - Type 'null' cannot be used as an index type.
            return Object.assign(Object.assign({}, sum), { [id]: sum[id] ? sum[id].concat(item) : [item] });
        }, {});
        // We could maybe assume that this will already be sorted by month descending because of the way that they are reduced
        // above, but it may not be a safe assumption.
        const sortedMonths = [...Object.keys(groupedByMonth)].sort(
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        (a, b) => new Date(b) - new Date(a));
        return sortedMonths.map((month, index) => ({
            feed: groupedByMonth[month],
            label: index === 0 ? null : month,
        }));
    }, [feed]);
    return (_jsx(_Fragment, { children: feedWithLabels.map((group, index) => (_jsxs("div", { children: [group.label && _jsx(HRWithLabel, { label: group.label, className: "my-4" }), group.feed.map((item) => {
                    var _a;
                    return (_jsx("div", { className: "mb-3", children: _jsx(ActivityItemWrapper, { item: item, setFeed: setFeed, hideItemEventTypes: hideItemEventTypes, editable: ((_a = editableItems.find((editableItem) => {
                                var _a, _b;
                                return ((_a = editableItem.id) === null || _a === void 0 ? void 0 : _a.toString()) ===
                                    ((_b = (item.activityItem.itemIdInt ||
                                        item.activityItem.itemIdUUID)) === null || _b === void 0 ? void 0 : _b.toString()) &&
                                    editableItem.activityItemTypeId ===
                                        item.activityItem.activityItemType.id;
                            })) === null || _a === void 0 ? void 0 : _a.editableUntil) || null }) }, `${item.activityItem.itemIdInt}-${item.activityItem.itemIdUUID}-${item.activityItem.activityItemType.id}`));
                })] }, index))) }));
};
export default ActivityFeedContent;
